import * as actions from './actions';
import * as types from './types';
import * as operations from './operations';
import deviceReducer from './reducers';

export default deviceReducer;

export {
  actions,
  operations,
  types,
};
